import { Root } from './styled-components';
export const ScrollView = Root;
